export enum TipoMultaStrategyEnum {

  FaixaMulta = "Multa por faixa de dias",
  MultaDiaria = "Multa diária"
}
